import * as React from 'react'
import { ISchool } from '../../interfaces/school.interface'
import InfoAppBar from '../../components/SchoolHomepage/DefaultHomepage/InfoAppBar'
import { ISchoolBlog } from '../../components/Blogs/useBlogs'
import BlogPostsListComponent from '../../components/Blogs/BlogPostsListComponent'
import SchoolFooter2 from '../../components/Footers/SchoolFooter2'
import { Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import BlogPostSubscriptionInput from '../../components/Blogs/BlogPostSubscriptionInput'

const BlogPostsListView = (props: {
  schoolDetails: ISchool
  posts: ISchoolBlog[]
}) => {
  const [useBackgroundImage] = React.useState(
    !props.schoolDetails?.hide_school_banner &&
      props.schoolDetails?.background_image,
  )
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div style={{ backgroundColor: '#131313' }}>
      <InfoAppBar
        school_details={props.schoolDetails}
        defaultStyle={{
          // backgroundColor: "#131313"
          marginTop: '-5px',
        }}
        // appbarStyle={{ boxShadow: "none" }}
        // linkStyle={{ color: "#fafafaa1" }}
      />

      <div
        style={
          useBackgroundImage
            ? {
                display: 'flex',
                height: '350px',
                width: '100%',
                alignItems: 'center',
                backgroundImage: props.schoolDetails?.background_image
                  ? `linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${props.schoolDetails?.background_image}')`
                  : "linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/img/bg_img_3.jpeg')",
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fff',
              }
            : {
                padding: '100px 20px',
                backgroundColor: '#1c1d1f',
                color: '#fff',
                height: '300px',
              }
        }
      >
        <div
          style={{
            minWidth: '40%',
            maxWidth: '300px',
            margin: 'auto',
          }}
        >
          <Typography
            gutterBottom={true}
            align={'center'}
            variant={isSmallScreen ? 'h4' : 'h3'}
            style={{
              marginTop: '40px',
              wordWrap: 'break-word',
            }}
          >
            <b> {props.schoolDetails.name}</b>
          </Typography>
          <Typography
            style={{
              marginBottom: '40px',
            }}
            align={'center'}
            gutterBottom={true}
            variant={isSmallScreen ? 'body2' : 'body1'}
            paragraph={true}
          >
            {props.schoolDetails.tagline}
          </Typography>
        </div>
      </div>
      <div style={{ padding: '100px 0px' }}>
        <BlogPostsListComponent
          schoolDetails={props.schoolDetails}
          posts={props.posts}
        />
        <div>
          <BlogPostSubscriptionInput
            textStyle={{ color: '#fff' }}
            school={props.schoolDetails}
          />
        </div>
      </div>

      <SchoolFooter2 schoolDetails={props.schoolDetails} />
    </div>
  )
}

export default BlogPostsListView
